module.exports = __webpack_public_path__ + "img/tws12.9686bb67.png";